
import React, { Component } from 'react';
import { Modal, Switch, Divider, Row, Col } from 'antd';

import moment from 'moment';

import messager from '../../ui/messager';
import http from '../../../axios/http';
import { moneyToCapital, moneyFormat } from '../../../util/util';

import { calculationTax, getTaxTicketItem } from './taxTicket.js';

const taxTypeArray = {
    '1': '个人',
    '2': '个体户',
    '3': '有限责任公司',
    '4': '有限责任公司',
};

class TaxPrint extends Component {

    state = {
        ticketItem: [{}, {}, {}, {}, {}],
        ticketData: {},
        needBuyer: false,
        needSeller: false,
        sellerData: {},
        buyerData: {},
        sellerTaxItem: [],
        buyerTaxItem: [],
        index: 0,

        invoiceNo: ''
    }

    print = () => {
        if (!this.state.needSeller) {
            messager.notify("无需打印税收缴款书！");
            return;
        }
        //保存数据到数据库
        this.savePrintInfo();

        var printHtml = window.document.getElementById('detail_print_div').innerHTML;
        var newWindow = window.open("", "print");
        newWindow.document.body.innerHTML = printHtml;
        newWindow.document.getElementsByTagName("html")[0].setAttribute('lang', 'zh-CN');
        newWindow.window.print();
        newWindow.window.close();
    };

    savePrintInfo = () => {
        let data = {};
        let ticketData = this.state.ticketData;
        data.id = ticketData.id;
        data.taxNo = ticketData.taxNo;
        data.ticketTime = moment().format('YYYY-MM-DD HH:mm:ss');
        data.taxAmount = ticketData.totalTaxAmount;
        data.payerType = this.state.index;
        data.taxAuthorities = ticketData.taxAuthorities;
        data.filler = ticketData.filler;
        let item = [];
        let ticketItem = this.state.ticketItem;
        for (let i = 0; i < ticketItem.length; i++) {
            if (JSON.stringify(ticketItem[i]) === "{}") {
            } else {
                item.push(ticketItem[i])
            }
        }
        data.taxItem = JSON.stringify(item);
        http.post({
            url: '/taxTicket/saveTaxTicketPrint',
            data: data,
            success: (res) => {
                if (this.props.successCallback) {
                    this.props.successCallback(this.props.queryData);
                }
            }
        });
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    initPrintData = (editData) => {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month < 10 ? ('0' + month) : month;
        let day = date.getDate();
        day = day < 10 ? ('0' + day) : day;
        let sellerTax = calculationTax(true, editData.sellerType, editData.amount);
        let needSeller = true;
        let sellerTaxItem = [{}, {}, {}, {}, {}];
        let needBuyer = false;
        let buyerTaxItem = [{}, {}, {}, {}, {}];
        let sellerData = {};
        let buyerData = {};

        //买家的基本信息
        sellerData.id = editData.id;
        sellerData.amount = editData.amount;
        sellerData.plateNo = editData.plateNo;
        sellerData.filler = editData.filler;
        sellerData.taxAuthorities = editData.taxAuthorities;
        sellerData.taxNo = editData.sellerTaxNoTemp;
        // sellerData.taxType = taxTypeArray[editData.sellerType];
        sellerData.taxType = this.payerTypeMatch(editData.sellerType, editData.sellerCreditNo, editData.sellerName);
        sellerData.creditNo = editData.sellerCreditNo;
        sellerData.name = editData.sellerName;
        sellerData.addr = editData.sellerAddr;
        sellerData.year = year;
        sellerData.month = month;
        sellerData.day = day;
        //卖家的基本信息
        buyerData.id = editData.id;
        buyerData.amount = editData.amount;
        buyerData.plateNo = editData.plateNo;
        buyerData.filler = editData.filler;
        buyerData.taxAuthorities = editData.taxAuthorities;
        buyerData.taxNo = editData.buyerTaxNoTemp;
        // buyerData.taxType = taxTypeArray[editData.buyerType];
        buyerData.taxType = this.payerTypeMatch(editData.buyerType, editData.sellerCreditNo, editData.buyerName);
        buyerData.creditNo = editData.buyerCreditNo;
        buyerData.name = editData.buyerName;
        buyerData.addr = editData.buyerAddr;
        buyerData.year = year;
        buyerData.month = month;
        buyerData.day = day;

        if (editData.sellerType === "1" && sellerTax.stampTax < 1) {
            //说明不需要打印交易票
            needSeller = false;
        }
        if (needSeller) {
            sellerTaxItem = getTaxTicketItem(editData.sellerType);
            if (editData.sellerType === "1") {
                //只需印花税
                sellerTaxItem[0].taxableAmount = editData.amount;
                sellerTaxItem[0].taxAmount = sellerTax.stampTax;
                sellerTaxItem.push({});
                sellerTaxItem.push({});
                sellerTaxItem.push({});
                sellerTaxItem.push({});
            } else {
                //计税金额
                sellerTaxItem[0].taxableAmount = sellerTax.addedTaxAmount;
                sellerTaxItem[1].taxableAmount = sellerTax.addedTax;
                sellerTaxItem[2].taxableAmount = sellerTax.addedTax;
                sellerTaxItem[3].taxableAmount = sellerTax.addedTax;
                sellerTaxItem[4].taxableAmount = editData.amount;
                //应缴纳的金额
                sellerTaxItem[0].taxAmount = sellerTax.addedTax;
                sellerTaxItem[1].taxAmount = sellerTax.constructionTax;
                sellerTaxItem[2].taxAmount = sellerTax.educationalSurtax;
                sellerTaxItem[3].taxAmount = sellerTax.localEducationalSurtax;
                sellerTaxItem[4].taxAmount = sellerTax.stampTax;
            }
            sellerData.amountCapital = moneyToCapital(sellerTax.totalTax);
            sellerData.totalTaxAmount = sellerTax.totalTax;

            let buyerTax = calculationTax(false, editData.buyerType, editData.amount);
            //如果印花税小于1块钱，则不需要
            //2021-01-11 买家不需要在市场纳税
            //needBuyer = !(buyerTax.stampTax < 1);
            if (needBuyer) {
                buyerTaxItem = getTaxTicketItem("1"); //买家都只需印花税
                //只需印花税
                buyerTaxItem[0].taxableAmount = editData.amount;
                buyerTaxItem[0].taxAmount = buyerTax.stampTax;
                buyerData.amountCapital = moneyToCapital(buyerTax.totalTax);
                buyerData.totalTaxAmount = buyerTax.totalTax;
                buyerTaxItem.push({});
                buyerTaxItem.push({});
                buyerTaxItem.push({});
                buyerTaxItem.push({});
            }
        }

        this.setState({
            needSeller: needSeller,
            needBuyer: needBuyer,
            sellerTaxItem: sellerTaxItem,
            buyerTaxItem: buyerTaxItem,
            sellerData: sellerData,
            buyerData: buyerData,
            ticketData: sellerData,
            ticketItem: sellerTaxItem,
            index: 0,

            invoiceNo: editData.invoiceNo
        });
    }

    payerTypeMatch = (type, creditNo, name) => {
        let taxType = taxTypeArray[type];
        if (type === 2 || type === "2") {
            let no = (creditNo + "").substr(0, 2);
            if (no === "91") {
                taxType = "有限责任公司";
            }
        }
        return taxType;
    }

    changeTax = (checked) => {
        if (checked) {
            //买家
            this.setState({
                ticketData: this.state.buyerData,
                ticketItem: this.state.buyerTaxItem,
                index: 1
            });
        } else {
            this.setState({
                ticketData: this.state.sellerData,
                ticketItem: this.state.sellerTaxItem,
                index: 0
            });
            //卖家
        }
    }

    render() {
        const { visible, onCancel } = this.props;
        const data = this.state.ticketData;
        const item = this.state.ticketItem;
        return (
            <Modal
                width={850}
                visible={visible}
                title="税收缴款书"
                okText="打印"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
            >
                <Row>
                    <Col span={12}>
                        <span>交易票号：{this.state["invoiceNo"]}</span>
                    </Col>
                    <Col span={12}>
                        {this.state.needBuyer ? <Switch checkedChildren="买家" unCheckedChildren="卖家" onClick={this.changeTax} checked={this.state.index === 1} /> : ''}
                    </Col>
                </Row>
                <Divider orientation="left">税票</Divider>
                <style>
                    {`
                        .print-div{width:795px !important;}
                        .text-right{text-align: right;}
                        .text-no-print{color: #b94343; display: inline !important;}
                        .tax-no{color: #ff0000; font-size: 14px;}
                        .none-border-table{width:100%;}
                        .border-table{width:100%;}
                        .border-table td{border: 1px solid #b94343;border-bottom:none;}
                        .top-border-table{width:100%;border: 1px solid #b94343;}
                        .top-border-table tr:first-child>td{border: 1px solid #b94343;}
                        .top-border-table tr:last-child>td{border: 1px solid #b94343;}
                        .top-border-table td{border-right: 1px solid #b94343;}
                        .right-border-table{border: 1px solid #b94343; border-top: none;}
                        .right-border-table tr>td:nth-child(-n+3){border-right: 1px solid #b94343;}
                        .td-no-print{height: 33px !important;}
                        .print-div{margin: 0 !important;}
                        .border-table td{text-align:center !important;}
                        .top-border-table td{text-align:center !important; }
                        .right-border-table td{text-align:center !important;}
                        .align-left-table td{text-align: left !important;}
                        .top-border-table .align-left-td{text-align: left !important;}
                        .text-print{font-size: 12px !important; font-weight: normal !important;}
                    `}
                </style>
                <div id="detail_print_div">
                    <style>
                        {`
                            .print-div{width:795px; font-size:12px !important; font-family: Microsoft YaHei,Simsun; margin: 0;}
                            .print-div td{ padding: 0; }
                            .none-border-table td{text-align:left;}
                            .border-table td{text-align:center;}
                            .top-border-table td{text-align:center; }
                            .right-border-table td{text-align:center;}
                            .text-no-print{display: none;}
                            .text-print{font-weight: 400 !important; font-family: Microsoft YaHei, Simsun !important; font-size: 12px !important;}
                            .td-no-print{height: 30px}
                            .none-border-table,
                            .border-table,
                            .top-border-table,
                            .right-border-table
                            {width:100%;}
                        `}
                    </style>
                    <div className="print-div">
                        <div>
                            <div className="text-right"><span className="text-no-print">（191）厦税现</span><span className="tax-no text-no-print">{data.taxNo}</span></div>
                        </div>
                        <table className="none-border-table ">
                            <tbody>
                                <tr>
                                    <td style={{ width: '100px' }}><span className="text-no-print">登记注册类型：</span></td>
                                    <td style={{ width: '165px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.taxType}</span></td>
                                    <td style={{ width: '70px' }}><span className="text-no-print">填发日期：</span></td>
                                    <td style={{ width: '35px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.year}</span></td>
                                    <td style={{ width: '15px' }}><span className="text-no-print">年</span></td>
                                    <td style={{ width: '35px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.month}</span></td>
                                    <td style={{ width: '15px' }}><span className="text-no-print">月</span></td>
                                    <td style={{ width: '35px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.day}</span></td>
                                    <td style={{ width: '15px' }}><span className="text-no-print">日</span></td>
                                    <td style={{ width: '100px', textAlign: 'right' }}><span className="text-no-print">税务机关：</span></td>
                                    <td style={{ width: '210px', textIndent: '5px', fontSize: '12px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.taxAuthorities}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="border-table align-left-table">
                            <tbody>
                                <tr>
                                    <td style={{ width: '86px', height: '27px' }}><span className="text-no-print">纳税人识别号</span></td>
                                    <td style={{ width: '291px', textAlign: 'left', textIndent: '10px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.creditNo}</span></td>
                                    <td style={{ width: '81px' }}><span className="text-no-print">纳税人名称</span></td>
                                    <td style={{ width: '332px', textAlign: 'left', textIndent: '10px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.name}</span></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '27px' }}><span className="text-no-print">地址</span></td>
                                    <td colSpan="3" style={{ textAlign: 'left', textIndent: '10px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.addr}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="top-border-table">
                            <tbody>
                                <tr>
                                    <td colSpan="2" style={{ width: '120px' }} className="td-no-print"><span className="text-no-print">税种</span></td>
                                    <td style={{ width: '140px' }}><span className="text-no-print">品目名称</span></td>
                                    <td style={{ width: '75px' }}><span className="text-no-print">课税数量</span></td>
                                    <td style={{ width: '75px' }}><span className="text-no-print">计税金额或销售收入</span></td>
                                    <td style={{ width: '60px' }}><span className="text-no-print">税率或单位税额</span></td>
                                    <td style={{ width: '125px' }}><span className="text-no-print">税款所属时期</span></td>
                                    <td style={{ width: '90px' }}><span className="text-no-print">已缴或扣除额</span></td>
                                    <td style={{ width: '110px' }}><span className="text-no-print">实缴金额</span></td>
                                </tr>
                                {item.map((d, index) => (
                                    <tr key={index}>
                                        <td colSpan="2" className="text-print" style={{ height: '42px', textAlign: 'left', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxCategory}</td>
                                        <td className="text-print" style={{ paddingRight: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.itemName}</td>
                                        <td className="text-print" style={{ paddingRight: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxationAmount}</td>
                                        <td className="text-print" style={{ paddingRight: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{moneyFormat(d.taxableAmount)}</td>
                                        <td className="text-print" style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxRate}</td>
                                        <td className="text-print" style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxDuration}</td>
                                        <td></td>
                                        <td className="text-print" style={{ textAlign: 'right', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{moneyFormat(d.taxAmount)}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td style={{ width: '65px', height: '30px', paddingTop: '0px' }}><span className="text-no-print">金额合计</span></td>
                                    <td style={{ width: '55px', borderRight: 'none', paddingTop: '0px' }}><span className="text-no-print">（大写）</span></td>
                                    <td colSpan="6" style={{ borderLeft: 'none', textAlign: 'left', paddingTop: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }} className='align-left-td'><span className="text-print">{data.amountCapital}</span></td>
                                    <td style={{ textAlign: 'right', paddingTop: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>
                                        <span className="text-print" >{moneyFormat(data.totalTaxAmount)}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="right-border-table">
                            <tbody>
                                <tr>
                                    <td style={{ width: '132px', height: '30px' }}></td>
                                    <td style={{ width: '132px' }}></td>
                                    <td style={{ width: '132px' }}></td>
                                    <td style={{ width: '30px' }}><span className="text-no-print">备注</span></td>
                                    <td style={{ width: '259px' }}></td>
                                    <td style={{ width: '110px' }}></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '30px' }}><span className="text-no-print">税务机关</span></td>
                                    <td><span className="text-no-print">代征单位</span></td>
                                    <td><span className="text-no-print">填票人</span></td>
                                    <td></td>
                                    <td style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.plateNo}</span></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '30px' }}><span className="text-no-print">（盖章）</span></td>
                                    <td><span className="text-no-print">（盖章）</span></td>
                                    <td style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.filler}</span></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{ textAlign: 'right', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{moneyFormat(data.amount)}</span></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '17px' }}></td>
                                    <td></td><td></td><td></td><td></td><td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        );
    }
}


export default TaxPrint;